import ApiService from "../../../../commons/services/ApiService";
import CompanyAPI from "../../../company/CompanyAPI";

const apiService = new ApiService();
const companyAPI = new CompanyAPI();

export default class PackageAPI {

  URI_V1 = "/v1/packages"

  create = async (data: any) => {
    return await apiService.post(`${this.URI_V1}?companyId=${companyAPI.getCompanyManagment().id}`, data);
  };

  findAll = async () => {
    return await apiService.get(`${this.URI_V1}?companyId=${companyAPI.getCompanyManagment().id}`);
  };

  updateStatus = async (id: any, status: any) => {
    return await apiService.put(`${this.URI_V1}/${id}/update-status?status=${status}&companyId=${companyAPI.getCompanyManagment().id}`, null);
  };

  delete = async (id: any) => {
    return await apiService.delete(`${this.URI_V1}/${id}?companyId=${companyAPI.getCompanyManagment().id}`);
  };

  findById = async (id: any) => {
    return await apiService.get(`${this.URI_V1}/${id}?companyId=${companyAPI.getCompanyManagment().id}`);
  };

  update = async (id: any, data: any) => {
    return await apiService.put(`${this.URI_V1}/${id}?companyId=${companyAPI.getCompanyManagment().id}`, data);
  };

}
